export const SET_SINGLE_FIELD = '[supplierInventory]SET_SINGLE_FIELD';
export const SET_MULTIPLE_FIELDS = '[supplierInventory]SET_MULTIPLE_FIELDS';
export const SET_SELECTED_VARIANTS = '[supplierInventory]SET_SELECTED_VARIANTS';
export const SET_BULK_VARIANT_EDIT = '[supplierInventory]SET_BULK_VARIANT_EDIT';
export const SET_LOADING = '[supplierInventory]SET_LOADING';

export const setBulkVariantEdit = ({ isLoading = false, isSuccess = undefined } = {}) => ({
  type: SET_BULK_VARIANT_EDIT,
  payload: {
    data: {
      isLoading,
      success: isSuccess,
    },
  },
});

export const setSelectedVariants = ({ variantIds = [], variantObjectIds = [], variantsWithDetails = [] } = {}) => ({
  type: SET_SELECTED_VARIANTS,
  payload: {
    variantIds: {
      ids: variantIds,
      objectIds: variantObjectIds,
      variantsWithDetails,
    },
  },
});

export const setInventory = ({ data, count }) => ({
  type: SET_MULTIPLE_FIELDS,
  payload: {
    keyValuePairs: {
      data: data,
      count: count,
      loading: {},
    },
  },
});
export const setOffset = (value) => ({
  type: SET_MULTIPLE_FIELDS,
  payload: {
    keyValuePairs: {
      offset: value,
      loading: { products: true },
    },
  },
});
export const setNumberOfRecordsPerPage = (value) => ({
  type: SET_MULTIPLE_FIELDS,
  payload: {
    keyValuePairs: {
      perPage: +value,
      loading: { products: true },
    },
  },
});
export const setSearchText = (value) => ({
  type: SET_MULTIPLE_FIELDS,
  payload: {
    keyValuePairs: {
      searchText: value,
      offset: 0,
      loading: { products: true },
    },
  },
});
export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: {
    loading,
  },
});
